import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { organisationsQueryKeys, searchOrganisations } from '@api/organisations';
import { MIN_SEARCH_LENGTH } from '@/react/utils/searchQuery';

export function useSearchOrganisations(query: string) {
  return useQuery({
    queryKey: organisationsQueryKeys.search(query),
    queryFn: () => searchOrganisations(query),
    enabled: query.length >= MIN_SEARCH_LENGTH,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
